export function formKeyToId(key: string): number {
  const id = key.split(':')[1];
  return Number(id);
}

export function idToKeyForm(id: number): string {
  return `key:${id}`;
}
